exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/* CSS Document */\n/*メインコンテンツ系*/\n/*tooltip font*/\n/*ステータスカラー*/\n/* Sass Document */\n/* Filetype Web Font **********************************************************/\narticle .tableitem {\n  width: 100%;\n  height: 100%;\n  background-color: #f0f0f0;\n  border-top: 1px solid #999999; }\narticle .tableitem__tablearea {\n    width: calc(100% - 30px);\n    height: calc(100% - 68px);\n    position: relative;\n    margin-left: 30px;\n    overflow: hidden; }\narticle .tableitem__tablearea div.ag-spread {\n      height: 100%; }\narticle .tableitem__tablearea div.ag-spread a.btn_secondary {\n        margin-right: 10px; }\narticle .tableitem__tablearea div.ag-spread div.itemcode {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: start;\n            -ms-flex-pack: start;\n                justify-content: flex-start; }\n._close {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9191/wa9191.component.scss
// module id = ../../../../../src/app/pages/wa9Master/wa9191/wa9191.component.scss
// module chunks = main